<header-title [model]="headerTitle"></header-title>

<section class="card mt-4" *ngIf="companyAuditModel">
    <header class="card-header">
        <div class="card-header-icon">
            <i class="fas fa-tasks"></i>
        </div>
        <h3>{{companyAuditModel.title}}</h3>
    </header>
    <div class="card-body audit-details">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <label>Created</label> {{companyAuditModel.startDate}}
                        </li>
                        <li class="list-inline-item">
                            <label>User</label> {{companyAuditModel.auditorName}}
                        </li>
                        <li class="list-inline-item">
                            <label>Type</label> {{companyAuditModel.auditTemplateDescription}}
                        </li>
                        <li class="list-inline-item" *ngIf="companyAuditModel.customerSurname">
                            <label>Customer</label> {{companyAuditModel.customerSurname}} {{companyAuditModel.customerInitial}}
                        </li>
                        <li class="list-inline-item">
                            <label>Status</label>
                            <span class="far fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==0" data-toggle="tooltip" title="Open"></span>
                            <span class="fas fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==1" data-toggle="tooltip" title="Completed"></span>
                        </li>
                        <li class="list-inline-item" *ngIf="companyAuditModel.completedDate">
                            <label>Completed</label> {{companyAuditModel.completedDate}}
                        </li>
                        <li class="list-inline-item" *ngIf="companyAuditModel.auditStatus==1">
                            <label>Rating</label>
                            <span *ngIf="totalPercentage<=25" data-toggle="tooltip" title="Positive - Well Done"><span class="fas fa-circle text-success"></span></span>
                            <span *ngIf="totalPercentage>25&&totalPercentage<=75" data-toggle="tooltip" title="OK - Needs Attention"><span class="fas fa-circle text-warning"></span></span>
                            <span *ngIf="totalPercentage>75" data-toggle="tooltip" title="Poor - High Risk"><span class="fas fa-circle text-danger"></span></span>
                        </li>
                    </ul>
                </div>
                <!--<div class="col-lg-6 audit-document-details">
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <label [class.text-danger]="auditDocuments?.length==0">
                                <span class="fas fa-file"></span> <span *ngIf="auditDocuments"> {{auditDocuments?.length}}</span> Document<span *ngIf="auditDocuments?.length!=1">s</span> uploaded
                            </label>
                        </li>
                        <li class="list-inline-item" *ngIf="auditDocuments && auditDocuments.length>0">
                            <button data-toggle="collapse" data-target="#audit-document-view" class="btn btn-link" title="View uploaded documents" *ngIf="auditDocuments.length>0"><span class="fas fa-eye"></span> View</button>
                        </li>
                    </ul>
                </div>-->
            </div>
        </div>
        <div class="container mt-5">
            <div class="row">
                <div class="col-12" id="audit-document-view">
                    <table class="table table-bordered">
                        <tbody>
                            <tr *ngFor="let doc of auditDocuments">
                                <td><span class="fas fa-file"></span> {{doc.fileName}}</td>
                                <td class="text-right">
                                    <a href="javascript:undefined;" (click)="this.companyAuditService.downloadGeneratedDocument(doc.id)"><span class="fas fa-download"></span> Download</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<section role="main" class="">
    <section class="card">
        <div class="card-body" *ngIf="questionsModel">

            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <error-message [errors]="errors"></error-message>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row qb-nav">
                    <div class="col-3 col-sm-2 col-lg-1 text-right"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == 0}" (click)="pageDown()" data-toggle="tooltip" data-placement="top" title="Previous"><i class="fas fa-chevron-circle-left"></i></button></div>
                    <div class="col-6 col-sm-8 col-lg-10">
                        <h4 class="text-center">Step {{pageNumber + 1}} of {{questionsModel?.length}}</h4>
                        <div class="progress progress-xs m-2 light">
                            <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" [style.width.%]="progress">
                                <span class="sr-only">{{progress}}%</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 col-sm-2 col-lg-1 text-left"><button class="btn btn-link" [ngClass]="{'disabled': pageNumber == questionsModel.length - 1}" (click)="pageUp()" data-toggle="tooltip" data-placement="top" title="Next"><i class="fas fa-chevron-circle-right"></i></button></div>
                </div>
            </div>

            <div class="container">
                <div class="row mt-5" *ngFor="let item of questionsModel; let i = index;" [hidden]="i!=pageNumber">
                    <div class="col">
                        <section class="card question-bank">
                            <header class="card-header clearfix">
                                <h2 class="card-title pull-left">{{item.questionBankName}}</h2>
                                <p class="pull-right">
                                    Section Rating:
                                    <span *ngIf="(item.score/(item.questions.length*2)*100)<=25"><span class="badge badge-pill badge-success badge-wrap text-2 font-weight-normal px-2 py-1">Positive - Well Done</span></span>
                                    <span *ngIf="(item.score/(item.questions.length*2)*100)>25&&(item.score/(item.questions.length*2)*100)<=75"><span class="badge badge-pill badge-warning badge-wrap text-2 font-weight-normal px-2 py-1">OK - Needs Attention</span></span>
                                    <span *ngIf="(item.score/(item.questions.length*2)*100)>75"><span class="badge badge-pill badge-danger badge-wrap text-2 font-weight-normal px-2 py-1">Poor - High Risk</span></span>
                                    <span style="display:none">{{item.score}}/{{item.questions.length*2}} {{item.score/(item.questions.length*2)*100}}</span>
                                </p>
                            </header>
                            <div class="card-body py-5">
                                <div class="panel-body">
                                    <div class="row row d-flex justify-content-center">
                                        <div class="col-12">
                                            <ng-container *ngFor="let question of item.questions">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row mt-3">
                                                            <div class="col-md-5">
                                                                <label class="control-label question-label" [attr.for]="question.key" [innerHtml]="question.label"></label>
                                                            </div>
                                                            <div class="col-md-6"><p>{{question.value}}</p></div>
                                                            <div class="col-md-1 score-flag text-right">
                                                                <span class="fa fa-check-circle text-success" *ngIf="question.score==0"></span>
                                                                <span class="fa fa-info-circle text-warning" *ngIf="question.score==1"></span>
                                                                <span class="fa fa-times-circle text-danger" *ngIf="question.score>=2"></span>
                                                            </div>
                                                        </div>
                                                        <div class="row" *ngIf="question.comment?.length>0">
                                                            <div class="col-12">
                                                                <div class="alert" [ngClass]="{'alert-danger':question.score>=2,'alert-warning':question.score==1,'alert-success':question.score==0}">
                                                                    {{question.comment}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="question-divider"></div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col">
                        <section class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-6 text-left">
                                        <button class="btn btn-warning ml-1" type="button" (click)="onBack()">Back to Audit Summary</button>
                                    </div>
                                    <div class="col-sm-6 text-right">
                                        <button class="btn btn-info ml-1" type="button" (click)="pageUp()" *ngIf="(pageNumber + 1) < questionsModel?.length">Next</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

        </div>
    </section>
</section>
